import { api } from './axios';
import { authService } from './auth';
import type { Feriado } from '../models';

interface FeriadoFilters {
  tipo?: 'NACIONAL' | 'ESTADUAL' | 'MUNICIPAL' | 'FOLGA';
  ano?: number;
}

interface CreateFeriadoData {
  data: string; // ISO date format (YYYY-MM-DD)
  descricao: string;
  tipo: 'NACIONAL' | 'ESTADUAL' | 'MUNICIPAL' | 'FOLGA';
  abrangencia_id?: number;
  pais_id?: number;
  estado_id?: number;
  cidade_id?: number;
}

interface UpdateFeriadoData {
  data?: string;
  descricao?: string;
  tipo?: 'NACIONAL' | 'ESTADUAL' | 'MUNICIPAL' | 'FOLGA';
  abrangencia_id?: number;
  pais_id?: number;
  estado_id?: number;
  cidade_id?: number;
}

class FeriadoService {
  /**
   * Listar todos os feriados com filtros opcionais
   */
  async getAll(filters?: FeriadoFilters): Promise<Feriado[]> {
    await authService.ensureSanctumInitialized();
    
    const params = new URLSearchParams();
    if (filters?.tipo) {
      params.append('tipo', filters.tipo);
    }
    if (filters?.ano) {
      params.append('ano', filters.ano.toString());
    }
    
    const queryString = params.toString();
    const url = queryString ? `/feriados?${queryString}` : '/feriados';
    
    const response = await api.get<Feriado[]>(url);
    return response.data;
  }

  /**
   * Obter feriado por ID
   */
  async getById(id: number): Promise<Feriado> {
    await authService.ensureSanctumInitialized();
    
    const response = await api.get<Feriado>(`/feriados/${id}`);
    return response.data;
  }

  /**
   * Criar novo feriado (apenas ADMIN)
   */
  async create(data: CreateFeriadoData): Promise<Feriado> {
    await authService.ensureSanctumInitialized();
    
    const response = await api.post<{ message: string; feriado: Feriado }>('/feriados', data);
    return response.data.feriado;
  }

  /**
   * Atualizar feriado existente (apenas ADMIN)
   */
  async update(id: number, data: UpdateFeriadoData): Promise<Feriado> {
    await authService.ensureSanctumInitialized();
    
    const response = await api.put<{ message: string; feriado: Feriado }>(`/feriados/${id}`, data);
    return response.data.feriado;
  }

  /**
   * Excluir feriado (apenas ADMIN)
   */
  async delete(id: number): Promise<void> {
    await authService.ensureSanctumInitialized();
    
    await api.delete(`/feriados/${id}`);
  }
}

export const feriadoService = new FeriadoService();

